import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";
import { useAuth } from "./auth";

const CurrencyCtx = createContext({ currency: "INR", rates: { INR: 1 }, supported: ["INR"], setCurrency: () => {} });

export function CurrencyProvider({ children }) {
  const { user, setUser } = useAuth();
  const [fx, setFx] = useState({ rates: { INR: 1 }, supported: ["INR"] });
  const [currency, setCur] = useState(localStorage.getItem("ab_currency") || "INR");
  useEffect(() => { api.get("/fx").then(r => setFx(r.data)).catch(() => {}); }, []);
  useEffect(() => { if (user?.preferred_currency) setCur(user.preferred_currency); }, [user?.preferred_currency]);
  const setCurrency = (c) => {
    setCur(c);
    localStorage.setItem("ab_currency", c);
    if (user) api.put("/auth/me/preferences", { preferred_currency: c }).then(r => setUser(r.data)).catch(() => {});
  };
  return <CurrencyCtx.Provider value={{ currency, setCurrency, ...fx }}>{children}</CurrencyCtx.Provider>;
}

export const useCurrency = () => useContext(CurrencyCtx);

export const fmtCurrency = (n, c) =>
  new Intl.NumberFormat(c === "INR" ? "en-IN" : "en-US", { style: "currency", currency: c, maximumFractionDigits: n >= 100 ? 0 : 2 }).format(n);

export function Est({ inr: amount, className = "" }) {
  const { currency, rates } = useCurrency();
  if (currency === "INR" || !rates[currency] || amount == null) return null;
  return (
    <span className={`text-[0.8em] font-medium opacity-70 ${className}`} title="Estimate only. You are charged in INR." data-testid="price-estimate">
      ≈ {fmtCurrency(Number(amount) * rates[currency], currency)}
    </span>
  );
}
